import {useTranslation} from '@aboutyou/i18n';

export const useLocalizedSortingOptions = () => {
  const {t} = useTranslation();
  return [
    {
      id: 'topseller',
      label: t('Top seller'),
    },
    {
      id: 'highest_reduction',
      label: t('Maximum reduction'),
    },
    {
      id: 'price_high',
      label: t('Highest price'),
    },
    {
      id: 'price_low',
      label: t('Lowest price'),
    },
    {
      id: 'new',
      label: t('New arrivals'),
    },
  ];
};
